import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import Footer from '@web/components/layouts/Footer';
import { Box } from '@mui/material';
import Sticky from '@web/Sticky';

const TopNav = dynamic(() => import('@web/components/layouts/TopNav'));

const HeroSection = dynamic(() => import('@web/pages-sections/HeroSection'));

const ShopLayout = ({ children }) => {
  const router = useRouter();
  const [isFixed, setIsFixed] = useState(false);
  const toggleIsFixed = useCallback((fixed) => setIsFixed(fixed), []);
  return (
    <>
      <Sticky fixedOn={0} scrollDistance={64} onSticky={toggleIsFixed}>
        <TopNav isFixed={isFixed} />
      </Sticky>
      {router.route === '/' && <HeroSection isFixed={isFixed} />}
      <Box
        sx={{
          mt: router.route === '/' ? 0 : 8,
          minHeight: '100vh',
        }}
      >
        {children}
      </Box>
      <Footer />
    </>
  );
};
export default ShopLayout;
